export default "__VITE_ASSET__BbyRbmew__"